import React, { useContext, useEffect, useState } from 'react'
import classes from './messages.module.scss'
import Button from '../button'
import PropTypes from 'prop-types'
import { useMutation } from '@apollo/client'
import { ADD_RETREAT_ENQUIRY } from '../../lib/queries'
import { useCookies } from 'react-cookie'
import LoginForm from '../account/login-form'
import moment from 'moment'
import { CartContext } from '../../lib/context/cart-context'
import { SettingsContext } from '../../lib/context/SettingsContext'

const MessageOverlay = ({
  user,
  room,
  retreatDetails,
  contact,
  onSend,
  checkIn,
  guests,
}) => {
  const { settings } = useContext(SettingsContext)
  const [numGuests, setNumGuests] = useState(guests)
  const [messageSent, setMessageSent] = useState(false)
  const [emailData, setEmailData] = useState({
    email: user && user.hasOwnProperty('email') ? user.email : '',
    name:
      user && user.hasOwnProperty('firstname') && user.firstname
        ? user.firstname + ' ' + user.lastname
        : '',
    subject: `Booking ${retreatDetails.name}`,
    message: '',
  })
  const { cartItems } = useContext(CartContext)
  const [cookies] = useCookies(['searchparams', 'cart'])
  const [createMessage] = useMutation(ADD_RETREAT_ENQUIRY)
  const handleDataChange = (evt) => {
    setEmailData({
      ...emailData,
      [`${evt.target.name}`]: evt.target.value,
    })
  }
  const moment = require('moment')
  const submitMessage = () => {
    let cartItemId = 0
    for (const item of cartItems) {
      const itemDate =
        typeof item.date === 'string' ? moment(item.date) : item.date
      if (
        item.type === 'retreat' &&
        item.id === retreatDetails.id &&
        itemDate.format('YYYY-MM-DD') === moment(checkIn).format('YYYY-MM-DD')
      ) {
        cartItemId = item.itemId
      }
    }
    // console.log({
    //   variables: {
    //     ...emailData,
    //     subject: `Wellness Traveller 111 - ${
    //       emailData.subject
    //     } [REF: ${moment().format('YYYYMMDDHHmm')}]`,
    //     recipient: contact.email,
    //     retreat: retreatDetails.id,
    //     checkIn: moment(checkIn).format('YYYY-MM-DD'),
    //     customer: user.hasOwnProperty('id') ? user.id : null,
    //     dateSent: new Date(),
    //     sent: true,
    //     type: 'Retreat',
    //     guests: numGuests,
    //     cart: cartItemId,
    //   },
    // })
    createMessage({
      variables: {
        ...emailData,
        subject: `Wellness Traveller 111 - ${
          emailData.subject
        } [REF: ${moment().format('YYYYMMDDHHmm')}]`,
        recipient: contact.email,
        retreat: retreatDetails.id,
        checkIn: moment(checkIn).format('YYYY-MM-DD'),
        customer: user.hasOwnProperty('id') ? user.id : null,
        dateSent: new Date(),
        sent: true,
        type: 'Retreat',
        guests: numGuests,
        cart: cartItemId,
      },
    })
      .then((resp) => {
        setMessageSent(true)
      })
      .catch((resp) => {
        // console.log(resp)
        setMessageSent(true)
      })
  }
  return (
    <div className={classes.newMessage}>
      {!messageSent && (
        <>
          {retreatDetails.enquiryIntro && retreatDetails.enquiryIntro !== '' && (
            <div
              dangerouslySetInnerHTML={{
                __html: retreatDetails.enquiryIntro,
              }}
            />
          )}
          {(!retreatDetails.enquiryIntro ||
            retreatDetails.enquiryIntro === '') &&
            settings.enquiryIntro && (
              <div
                dangerouslySetInnerHTML={{
                  __html: settings.enquiryIntro.retreatEnquiry,
                }}
              />
            )}
          <ul className={classes.eventDetails}>
            <li>
              <strong>Check-in: </strong> {moment(checkIn).format('DD/MM/YYYY')}
            </li>
            <li>
              <strong>Nr Guests: </strong> {numGuests}
            </li>
          </ul>
          <div className={classes.messageRow}>
            <input
              type="text"
              value={emailData.name}
              placeholder="Full name"
              onChange={handleDataChange}
              name="name"
              className={classes.half}
            />
            <input
              type="text"
              value={emailData.email}
              placeholder="Email Address"
              onChange={handleDataChange}
              name="email"
              className={classes.half}
            />
          </div>
          <div className={classes.messageRow}>
            <input
              type="text"
              value={emailData.subject}
              placeholder="Subject"
              onChange={handleDataChange}
              name="subject"
            />
          </div>
          <div className={classes.messageRow}>
            <textarea
              value={emailData.message}
              placeholder="Your Message"
              onChange={handleDataChange}
              name="message"
              rows={6}
            />
          </div>
          <div className={classes.messageActions}>
            <Button width="100%" onClick={submitMessage} className={'cta-event-trigger'}>
              Send Message
            </Button>
          </div>
        </>
      )}
      {messageSent && emailData.email !== null && (
        <p>
          We&apos;ll be right back! A response will be in your Wellness
          Traveller account messages within 24 hours.
        </p>
      )}
    </div>
  )
}
MessageOverlay.propTypes = {
  onSend: PropTypes.func.isRequired,
  user: PropTypes.object,
  room: PropTypes.object,
  retreatDetails: PropTypes.object,
  contact: PropTypes.object.isRequired,
  checkIn: PropTypes.string,
  checkOut: PropTypes.string,
  guests: PropTypes.number || PropTypes.array,
}
export default MessageOverlay
